import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Pages404 from "../pages/Dashboard/pages-404"
import AdminHome from "../pages/Admin/AdminHome"

// Products
import AddProduct from "../pages/Product/AddProduct"

import PurchaseEntry from "../pages/Purchase/PurchaseEntry"
import SalesEntry from "../pages/Sales/SalesEntry"
import PaymentEntry from "../pages/Sales/PaymentEntry"
import PurchasePaymentEntry from "../pages/Purchase/PurchasePaymentEntry"
import ExpensePaymentEntry from "../pages/Purchase/ExpensePaymentEntry"
import CashInputEntry from "../pages/Purchase/CashInputEntry"
import SalesReturnEntry from "../pages/Sales/SalesReturnEntry"


import CategorySubCategoryList from "../pages/ListItems/CategorySubCategoryList"
import HSNList from "../pages/ListItems/HSNList"
import UnitList from "../pages/ListItems/UnitList"
import TaxList from "../pages/ListItems/TaxList"
import SupplierList from "../pages/ListItems/SupplierList"
import CustomerList from "../pages/ListItems/CustomerList"
import EmployeeList from "../pages/ListItems/EmployeeList"
import BankList from "../pages/ListItems/BankList"

import BrandList from "../pages/ListItems/BrandList"
import ManufacturerList from "../pages/ListItems/ManufacturerList"
import ColourList from "../pages/ListItems/ColourList"
import SizeList from "../pages/ListItems/SizeList"
import COAList from "../pages/ListItems/COAList"
import ProductList from "../pages/ListItems/ProductList"
import PurchaseEntryList from "../pages/ListItems/PurchaseEntryList"
import SalesEntryList from "../pages/ListItems/SalesEntryList"
import SalesReceiptList from "../pages/ListItems/SalesReceiptList"
import ExpenseList from "../pages/ListItems/ExpenseList"
import CashInputList from "../pages/ListItems/CashInputList"


import CustomerListDetailed from "../pages/ListItems/CustomerListDetailed"
import EmployeeListDetailed from "../pages/ListItems/EmployeeListDetailed"


import SupplierListAndDetails from "../pages/ListItems/SupplierListAndDetails"
import ProductListWithDetails from "../pages/Product/ProductListWithDetails"

import PurchasePaymentList from "../pages/ListItems/PurchasePaymentList"
import SettingsHome from "../pages/Settings/SettingsHome"

import ReportsHome from "../pages/Reports/ReportsHome"
import DayReport from "../pages/Reports/DayReport"
import SalesReport from "../pages/Reports/SalesReport"
import ProfitReport from "../pages/Reports/ProfitReport"
import PrintPriceTag from "../pages/Product/PrintPriceTag"


const userRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/superadmin-home", component: AdminHome },
  { path: "/view-products", component:  ProductList},
  { path: "/view-products/:id", component:  ProductListWithDetails},
  { path: "/add-product", component: AddProduct },
  { path: "/edit-product/:id", component: AddProduct },
  { path: "/list-category-subcategory", component: CategorySubCategoryList },
  { path: "/list-hsn", component: HSNList },
  { path: "/list-unit", component: UnitList },
  { path: "/list-tax", component: TaxList },
  { path: "/list-supplier", component: SupplierList },
  { path: "/list-supplier/:id", component: SupplierListAndDetails },
  { path: "/list-customer", component: CustomerList },
  { path: "/list-customer/:id", component: CustomerListDetailed },

  { path: "/list-employee", component: EmployeeList },
  { path: "/list-employee/:id", component: EmployeeListDetailed },
  
  { path: "/list-banks", component: BankList },
  { path: "/list-expenses", component: ExpenseList },
  { path: "/list-cash-input", component: CashInputList },
  
  { path: "/list-expenses/:id", component: ExpensePaymentEntry },
  
  { path: "/list-brand", component: BrandList },
  { path: "/list-manufacturer", component: ManufacturerList },
  { path: "/list-colour", component: ColourList },
  { path: "/list-size", component: SizeList },

  { path: "/list-coa", component: COAList },
  { path: "/price-tags", component: PrintPriceTag },
  
  { path: "/add-purchase", component: PurchaseEntry },
  { path: "/view-purchase-entries", component:  PurchaseEntryList},
  { path: "/edit-purchaseentry/:id", component: PurchaseEntry },
  { path: "/add-purchase-payment", component: PurchasePaymentEntry },
  { path: "/add-purchase-payment/:id", component: PurchasePaymentEntry },
  { path: "/view-purchase-payments", component:  PurchasePaymentList},
  { path: "/add-expense-payment", component: ExpensePaymentEntry },
  { path: "/add-cash-input", component: CashInputEntry },

  { path: "/add-sales", component: SalesEntry },
  { path: "/add-sales-payment", component: PaymentEntry },
  { path: "/add-sales-payment/:id", component: PaymentEntry },
  { path: "/view-sales-entries", component:  SalesEntryList},
  { path: "/view-sales-entries/:id", component:  SalesEntryList},
  { path: "/view-sales-receipts", component:  SalesReceiptList},
  { path: "/edit-salesentry/:id", component: SalesEntry },
  { path: "/sales-return/:id", component: SalesReturnEntry },
  

  { path: "/profile", component: UserProfile },

  { path: "/pages-404", component: Pages404 },

  
  { path: "/all-settings", component: SettingsHome },
  { path: "/all-reports", component: ReportsHome },
  { path: "/report-day-book", component: DayReport },
  { path: "/report-sales", component: SalesReport },
  { path: "/report-profit", component: ProfitReport },
  

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/pages404", component: Pages404 },
]

export { userRoutes, authRoutes }
